import uat from './uat.js'
import prod from './prod.js'
import local from './local.js'

let config

if (process.env.VUE_APP_SERVER_ENV === 'PROD') {
  config = prod
} else if (process.env.VUE_APP_SERVER_ENV === 'UAT') {
  config = uat
} else { // LOCAL
  config = { ...uat, ...local } // base on UAT config
}

config.isWeb = process.env.VUE_APP_MODE === 'WEB'
config.isApp = process.env.VUE_APP_MODE === 'APP'
config.isPwa = process.env.VUE_APP_MODE === 'PWA'
config.isInGaApp = process.env.VUE_APP_IN_GA_APP === '1'
config.isGaWeb = process.env.VUE_APP_GA_WEB === '1'
config.isBrowser = (process.env.VUE_APP_MODE === 'WEB' || process.env.VUE_APP_MODE === 'PWA')

export default {
  ...config
}
